import axios from 'axios';
import {checkErrors} from './errors';

export const LOADFLOORPLANS_REQUESTED = 'floorplans/LOADFLOORPLANS_REQUESTED';
export const LOADFLOORPLANS_FINISHED = 'floorplans/LOADFLOORPLANS_FINISHED';
export const SETFLOORPLANS = 'floorplans/SETFLOORPLANS';
export const SETFLOORPLANSKIN = 'floorplans/SETFLOORPLANSKIN';
export const SETACTIVEFLOORPLAN = 'floorplans/SETACTIVEFLOORPLAN';
export const SETTRANSLATEX = 'floorplans/SETTRANSLATEX';
export const SETTRANSLATEY = 'floorplans/SETTRANSLATEY';
export const SETZOOM = 'floorplans/SETZOOM';

export const SETTEMPADDFLOORPLAN = 'floorplans/SETTEMPADDFLOORPLAN';
export const ADDFLOORPLAN_REQUESTED = 'floorplans/ADDFLOORPLAN_REQUESTED';
export const ADDFLOORPLAN_FINISHED = 'floorplans/ADDFLOORPLAN_FINISHED';

export const EDITFLOORPLAN_REQUESTED = 'floorplans/EDITFLOORPLAN_REQUESTED';
export const EDITFLOORPLAN_FINISHED = 'floorplans/EDITFLOORPLAN_FINISHED';

export const REMOVEFLOORPLAN_REQUESTED = 'floorplans/REMOVEFLOORPLAN_REQUESTED';
export const REMOVEFLOORPLAN_FINISHED = 'floorplans/REMOVEFLOORPLAN_FINISHED';

export const SHOWPATHPOPOVER = 'floorplans/SHOWPATHPOPOVER';
export const SETACTIVEPATH = 'floorplans/SETACTIVEPATH';
export const SETPATHPOPOVERX = 'floorplans/SETPATHPOPOVERX';
export const SETPATHPOPOVERY = 'floorplans/SETPATHPOPOVERY';

export const SHOWPOINTPOPOVER = 'floorplans/SHOWPOINTPOPOVER';
export const SETACTIVEPOINT = 'floorplans/SETACTIVEPOINT';
export const SETPOINTPOPOVERX = 'floorplans/SETPOINTPOPOVERX';
export const SETPOINTPOPOVERY = 'floorplans/SETPOINTPOPOVERY';

export const SETGRIDLINES = 'floorplans/SETGRIDLINES';
export const SETROTATION = 'floorplans/SETROTATION';
export const SETTOGGLEPOINTS = 'floorplans/SETTOGGLEPOINTS';
export const SETTOGGLEAMENITIES = 'floorplans/SETTOGGLEAMENITIES';
export const SETTOGGLEKIOSKS = 'floorplans/SETTOGGLEKIOSKS';
export const SETTOGGLEPATHIDS = 'floorplans/SETTOGGLEPATHIDS';

export const SETACTIVEAMENITY = 'floorplans/SETACTIVEAMENITY';

export const SHOWAMENITYASSIGNMENTPOPOVER = 'floorplans/SHOWAMENITYASSIGNMENTPOPOVER';
export const SETACTIVEAMENITYASSIGNMENT = 'floorplans/SETACTIVEAMENITYASSIGNMENT';
export const SETAMENITYASSIGNMENTPOPOVERX = 'floorplans/SETAMENITYASSIGNMENTPOPOVERX';
export const SETAMENITYASSIGNMENTPOPOVERY = 'floorplans/SETAMENITYASSIGNMENTPOPOVERY';

export const SETACTIVEKIOSK = 'floorplans/SETACTIVEKIOSK';

export const SHOWKIOSKASSIGNMENTPOPOVER = 'floorplans/SHOWKIOSKASSIGNMENTPOPOVER';
export const SETACTIVEKIOSKASSIGNMENT = 'floorplans/SETACTIVEKIOSKASSIGNMENT';
export const SETKIOSKASSIGNMENTPOPOVERX = 'floorplans/SETKIOSKASSIGNMENTPOPOVERX';
export const SETKIOSKASSIGNMENTPOPOVERY = 'floorplans/SETKIOSKASSIGNMENTPOPOVERY';
export const SETKIOSKASSIGNMENTROTATION = 'floorplans/SETKIOSKASSIGNMENTROTATION';

const initialState = {
  floorplans: [],
  floorplanSkin: [],
  activeFloorplanID: null,
  translateX: 0,
  translateY: 0,
  zoom: 0.02,
  isLoadingFloorplans: false,
  activePath: null,
  showPathPopover: false,
  pathPopOverX: 0,
  pathPopOverY: 0,
  activePoint: null,
  showPointPopover: false,
  pointPopoverX: 0,
  pointPopOverY: 0,
  tempAddFloorplan: null,
  isAddingFloorplan: false,
  isEditingFloorplan: false,
  gridLines: false,
  rotation: 0,
  showPoints: true,
  showAmenities: true,
  showKiosks: true,
  showPathIDs: true,
  activeAmenity: null,
  showAmenityAssignmentPopover: false,
  activeAmenityAssignment: null,
  amenityAssignmentPopoverX: 0,
  amenityAssignmentPopoverY: 0,
  activeKiosk: null,
  showKioskAssignmentPopover: false,
  activeKioskAssignment: null,
  kioskAssignmentPopoverX: 0,
  kioskAssignmentPopoverY: 0,
  kioskAssignmentRotation: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADFLOORPLANS_REQUESTED:
    return {
      ...state,
      isLoadingFloorplans: true
    };

  case LOADFLOORPLANS_FINISHED:
    return {
      ...state,
      isLoadingFloorplans: false
    };

  case SETFLOORPLANS:
    
    return {
      ...state,
      floorplans: action.floorplans
    };

    case SETFLOORPLANSKIN:
    
      return {
        ...state,
        floorplanSkin: action.floorplanSkin
      };

  case SETACTIVEFLOORPLAN:
    return {
      ...state,
      activeFloorplanID: action.activeFloorplanID
    }

  case SETTRANSLATEX:
    
    return {
      ...state,
      translateX: action.x
    };

  case SETTRANSLATEY:
    
    return {
      ...state,
      translateY: action.y
    };

  case SETZOOM:
    
    return {
      ...state,
      zoom: action.z
    };

  case SHOWPATHPOPOVER:
    
    return {
      ...state,
      showPathPopover: action.showPathPopover
    };

  case SETACTIVEPATH:
    
    return {
      ...state,
      activePath: action.activePath
    };
  
  case SETPATHPOPOVERX:
    
    return {
      ...state,
      pathPopoverX: action.x
    };

  case SETPATHPOPOVERY:
    
    return {
      ...state,
      pathPopoverY: action.y
    };

  case SHOWPOINTPOPOVER:
    
    return {
      ...state,
      showPointPopover: action.showPointPopover
    };

  case SETACTIVEPOINT:
    
    return {
      ...state,
      activePoint: action.activePoint
    };
  
  case SETPOINTPOPOVERX:
    
    return {
      ...state,
      pointPopoverX: action.x
    };

  case SETPOINTPOPOVERY:
    
    return {
      ...state,
      pointPopoverY: action.y
    };
  
  case SETTEMPADDFLOORPLAN:
    
    return {
      ...state,
      tempAddFloorplan: action.floorplan
    };
  
  case ADDFLOORPLAN_REQUESTED:
    return {
      ...state,
      isAddingFloorplan: true
    };

  case ADDFLOORPLAN_FINISHED:
    return {
      ...state,
      isAddingFloorplan: false
    };

  case EDITFLOORPLAN_REQUESTED:
    return {
      ...state,
      isEditingFloorplan: true
    };

  case EDITFLOORPLAN_FINISHED:
    return {
      ...state,
      isEditingFloorplan: false
    };
  
  case REMOVEFLOORPLAN_REQUESTED:
    return {
      ...state,
      isRemovingFloorplan: true
    }; 

  case REMOVEFLOORPLAN_FINISHED:
    return {
      ...state,
      isRemovingFloorplan: false
    };

  case SETGRIDLINES:
    return {
      ...state,
      gridLines: action.gridLines
    }

  case SETROTATION:
    return {
      ...state,
      rotation: action.rotation
    }
  
  case SETTOGGLEPOINTS:
    return {
      ...state,
      showPoints: action.showPoints
    }

  case SETTOGGLEAMENITIES:
    return {
      ...state,
      showAmenities: action.showAmenities
    }

  case SETTOGGLEKIOSKS:
    return {
      ...state,
      showKiosks: action.showKiosks
    }

  case SETTOGGLEPATHIDS:
    return {
      ...state,
      showPathIDs: action.showPathIDs
    }

  case SETACTIVEAMENITY:
    return {
      ...state,
      activeAmenity: action.activeAmenityID
    }

  case SHOWAMENITYASSIGNMENTPOPOVER:
    
    return {
      ...state,
      showAmenityAssignmentPopover: action.showAmenityAssignmentPopover
    };

  case SETACTIVEAMENITYASSIGNMENT:
    
    return {
      ...state,
      activeAmenityAssignment: action.activeAmenityAssignment
    };
  
  case SETAMENITYASSIGNMENTPOPOVERX:
    
    return {
      ...state,
      amenityAssignmentPopoverX: action.x
    };

  case SETAMENITYASSIGNMENTPOPOVERY:
    
    return {
      ...state,
      amenityAssignmentPopoverY: action.y
    };

  case SETACTIVEKIOSK:
    return {
      ...state,
      activeKiosk: action.activeKioskID
    }

  case SHOWKIOSKASSIGNMENTPOPOVER:
    
    return {
      ...state,
      showKioskAssignmentPopover: action.showKioskAssignmentPopover
    };

  case SETACTIVEKIOSKASSIGNMENT:
    
    return {
      ...state,
      activeKioskAssignment: action.activeKioskAssignment
    };
  
  case SETKIOSKASSIGNMENTPOPOVERX:
    
    return {
      ...state,
      kioskAssignmentPopoverX: action.x
    };

  case SETKIOSKASSIGNMENTPOPOVERY:
    
    return {
      ...state,
      kioskAssignmentPopoverY: action.y
    };

  case SETKIOSKASSIGNMENTROTATION:
    return {
      ...state,
      kioskAssignmentRotation: action.rotation
    };

  default:
    return state;
  }
};


export const loadFloorplans = () => {
  return (dispatch, getState) => {    
    const floorplansState = getState().floorplans;

    dispatch({
      type: LOADFLOORPLANS_REQUESTED
    });

    axios.get(`${window.endpoint}/floorplans`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: LOADFLOORPLANS_FINISHED
      });

      if(response.data.floorplans.length > 0) {
        // filter floorplans by active
        const floorplans = response.data.floorplans.filter((floorplan) => {
          return floorplan.is_active === 1;
        });

        // sort floorplans by floorplan_level
        floorplans.sort((floorplanA, floorplanB) => {
          if(floorplanA.floorplan_level < floorplanB.floorplan_level) return -1;
          if(floorplanA.floorplan_level > floorplanB.floorplan_level) return 1;
          return 0;
        });
  
        dispatch({
          type: SETFLOORPLANS,
          floorplans
        });
  
        if(!floorplansState.activeFloorplanID){
          dispatch({
            type: SETACTIVEFLOORPLAN,
            activeFloorplanID: floorplans[0].floorplan_id
          })
        }
      }
      
    })
    
  };
};

export const getFloorplanSkin = () => {
  return (dispatch, getState) => {
    const floorplansState = getState().floorplans;
    if(floorplansState.activeFloorplanID){
      axios.get(`${window.endpoint}/floorplans/${floorplansState.activeFloorplanID}/skin`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
        if(response.data.length > 0) {          
          dispatch({
            type: SETFLOORPLANSKIN,
            floorplanSkin: response.data[0]
          });
        }
      })
    }    
    
  };
};


export const setActiveFloorplan = (activeFloorplanID) => {
  return dispatch => {
    dispatch({
      type: SETACTIVEFLOORPLAN,
      activeFloorplanID
    });
  };
};

export const setTranslateX = (x) => {
  return dispatch => {
    dispatch({
      type: SETTRANSLATEX,
      x
    });
  };
};

export const setTranslateY = (y) => {
  return dispatch => {
    dispatch({
      type: SETTRANSLATEY,
      y
    });
  };
};

export const setZoom = (z) => {
  return dispatch => {
    dispatch({
      type: SETZOOM,
      z
    });
  };
};

export const showHidePathPopover = (showPathPopover) => {
  return dispatch => {
    dispatch({
      type: SHOWPATHPOPOVER,
      showPathPopover
    });
  };
};

export const setActivePath = (activePath) => {
  return dispatch => {

    // activePoint.SVGItem.select('circle.point-item').fill('#FFE380');
    // activePoint.SVGItem.select('text.point-name').first().font({fill: '#FFE380'});

    dispatch({
      type: SETACTIVEPATH,
      activePath
    });
  };
}

export const setPathPopoverX = (x) => {
  return dispatch => {
    dispatch({
      type: SETPATHPOPOVERX,
      x
    });
  };
};

export const setPathPopoverY = (y) => {
  return dispatch => {
    dispatch({
      type: SETPATHPOPOVERY,
      y
    });
  };
};

export const setActivePoint = (activePoint) => {
  return dispatch => {

    // activePoint.SVGItem.select('circle.point-item').fill('#FFE380');
    // activePoint.SVGItem.select('text.point-name').first().font({fill: '#FFE380'});

    dispatch({
      type: SETACTIVEPOINT,
      activePoint
    });
  };
}

export const showHidePointPopover = (showPointPopover) => {
  return (dispatch, getState) => {

    if(!showPointPopover && getState().floorplans.activePoint){
      // getState().floorplans.activePoint.SVGItem.select('circle.point-item').fill('#f06');
      // getState().floorplans.activePoint.SVGItem.select('text.point-name').first().font({fill: '#f06'});
    }

    dispatch({
      type: SHOWPOINTPOPOVER,
      showPointPopover
    });
  };
};

export const setPointPopoverX = (x) => {
  return dispatch => {
    dispatch({
      type: SETPOINTPOPOVERX,
      x
    });
  };
};

export const setPointPopoverY = (y) => {
  return dispatch => {
    dispatch({
      type: SETPOINTPOPOVERY,
      y
    });
  };
};

export const setTempAddFloorplan = (floorplan) => {
  return dispatch => {
    dispatch({
      type: SETTEMPADDFLOORPLAN,
      floorplan
    });
  };
};

export const addFloorplan = (data, cb) => {
  return dispatch => {
    dispatch({
      type: ADDFLOORPLAN_REQUESTED
    });

    axios({method: 'post', url: `${window.endpoint}/floorplans`, data, headers: { Authorization: localStorage.getItem(window.token) }})
      .then((response) => {

        dispatch({
          type: ADDFLOORPLAN_FINISHED
        });

        dispatch({
          type: SETTEMPADDFLOORPLAN,
          floorplan: null
        });

        if (cb instanceof Function) { cb(); }

      }).catch((error) => {
        checkErrors(error);
      });
    
  };
};

export const editFloorplan = (id, data, cb) => {
  return dispatch => {
    dispatch({
      type: EDITFLOORPLAN_REQUESTED
    });

    axios({method: 'post', url: `${window.endpoint}/floorplans/${id}`, data, headers: { Authorization: localStorage.getItem(window.token) }})
      .then((response) => {

        dispatch({
          type: EDITFLOORPLAN_FINISHED
        });

        if (cb instanceof Function) { cb(); }

      }).catch((error) => {
        checkErrors(error);
      });
    
  };
};

export const removeFloorplan = (floorplanID, cb) => {
  return dispatch => {
    dispatch({
      type: REMOVEFLOORPLAN_REQUESTED
    });

    axios({method: 'delete', url: `${window.endpoint}/floorplans/${floorplanID}`, headers: { Authorization: localStorage.getItem(window.token) }})
      .then((response) => {

        dispatch({
          type: REMOVEFLOORPLAN_FINISHED
        });

        if (cb instanceof Function) { cb(); }

      }).catch((error) => {
        checkErrors(error);
      });
    
  };
};

export const addFloorplanSkin = (floorplanID, data, cb) => {
  return dispatch => {

    axios({method: 'post', url: `${window.endpoint}/floorplans/${floorplanID}/skin`, data, headers: { Authorization: localStorage.getItem(window.token) }})
      .then((response) => {

        if (cb instanceof Function) { cb(); }

      }).catch((error) => {
        checkErrors(error);
      });
    
  };
};

export const removeFloorplanSkin = (floorplanID, cb) => {
  return dispatch => {
    axios({method: 'delete', url: `${window.endpoint}/floorplans/${floorplanID}/skin`, headers: { Authorization: localStorage.getItem(window.token) }})
      .then((response) => {   
        console.log(response)

        if (cb instanceof Function) { cb(); }

      }).catch((error) => {
        checkErrors(error);
        console.log(error)
      });
    
  };
};

export const toggleGridLines = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETGRIDLINES,
      gridLines: !getState().floorplans.gridLines
    });
  };
};

export const setRotation = (rotation) => {
  return (dispatch) => {
    dispatch({
      type: SETROTATION,
      rotation
    });
  };
};

export const togglePoints = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTOGGLEPOINTS,
      showPoints: !getState().floorplans.showPoints
    });
  };
};

export const toggleAmenities = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTOGGLEAMENITIES,
      showAmenities: !getState().floorplans.showAmenities
    });
  };
};

export const toggleKiosks = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTOGGLEKIOSKS,
      showKiosks: !getState().floorplans.showKiosks
    });
  };
};

export const togglePathIDs = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTOGGLEPATHIDS,
      showPathIDs: !getState().floorplans.showPathIDs
    });
  };
};

export const setActiveAmenity = (activeAmenityID) => {
  return dispatch => {

    // activePoint.SVGItem.select('circle.point-item').fill('#FFE380');
    // activePoint.SVGItem.select('text.point-name').first().font({fill: '#FFE380'});

    dispatch({
      type: SETACTIVEAMENITY,
      activeAmenityID
    });
  };
}

export const setActiveAmenityAssignment = (activeAmenityAssignment) => {
  return dispatch => {

    dispatch({
      type: SETACTIVEAMENITYASSIGNMENT,
      activeAmenityAssignment
    });
  };
}

export const showHideAmenityAssignmentPopover = (showAmenityAssignmentPopover) => {
  return (dispatch, getState) => {

    // if(!showPointPopover && getState().floorplans.activePoint){
    //   // getState().floorplans.activePoint.SVGItem.select('circle.point-item').fill('#f06');
    //   // getState().floorplans.activePoint.SVGItem.select('text.point-name').first().font({fill: '#f06'});
    // }

    dispatch({
      type: SHOWAMENITYASSIGNMENTPOPOVER,
      showAmenityAssignmentPopover
    });
  };
};

export const setAmenityAssignmentPopoverX = (x) => {
  return dispatch => {
    dispatch({
      type: SETAMENITYASSIGNMENTPOPOVERX,
      x
    });
  };
};

export const setAmenityAssignmentPopoverY = (y) => {
  return dispatch => {
    dispatch({
      type: SETAMENITYASSIGNMENTPOPOVERY,
      y
    });
  };
};

export const setActiveKiosk = (activeKioskID) => {
  return dispatch => {

    // activePoint.SVGItem.select('circle.point-item').fill('#FFE380');
    // activePoint.SVGItem.select('text.point-name').first().font({fill: '#FFE380'});

    dispatch({
      type: SETACTIVEKIOSK,
      activeKioskID
    });
  };
}

export const setActiveKioskAssignment = (activeKioskAssignment) => {
  return dispatch => {

    dispatch({
      type: SETACTIVEKIOSKASSIGNMENT,
      activeKioskAssignment
    });
  };
}

export const showHideKioskAssignmentPopover = (showKioskAssignmentPopover) => {
  return (dispatch, getState) => {

    // if(!showPointPopover && getState().floorplans.activePoint){
    //   // getState().floorplans.activePoint.SVGItem.select('circle.point-item').fill('#f06');
    //   // getState().floorplans.activePoint.SVGItem.select('text.point-name').first().font({fill: '#f06'});
    // }

    dispatch({
      type: SHOWKIOSKASSIGNMENTPOPOVER,
      showKioskAssignmentPopover
    });
  };
};

export const setKioskAssignmentPopoverX = (x) => {
  return dispatch => {
    dispatch({
      type: SETKIOSKASSIGNMENTPOPOVERX,
      x
    });
  };
};

export const setKioskAssignmentPopoverY = (y) => {
  return dispatch => {
    dispatch({
      type: SETKIOSKASSIGNMENTPOPOVERY,
      y
    });
  };
};

export const setKioskAssignmentRotation = (rotation) => {
  return dispatch => {
    dispatch({
      type: SETKIOSKASSIGNMENTROTATION,
      rotation
    });
  };
};


// WEBPACK FOOTER //
// ./src/reducers/floorplans.js